var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0679 17.9447V6.80319L15.7647 0.5H5.11866C4.6692 0.5 4.23807 0.678573 3.9201 0.996372C3.6023 1.31436 3.42373 1.74548 3.42373 2.19493V16.4924C3.29529 16.5661 3.18841 16.6723 3.11407 16.8005C3.03972 16.9286 3.00038 17.0739 3 17.222V23.3813C3.00076 23.943 3.22416 24.4815 3.62122 24.8788C4.01846 25.2758 4.55701 25.4992 5.11866 25.5H20.373C20.9347 25.4992 21.4732 25.2758 21.8704 24.8788C22.2675 24.4815 22.4909 23.943 22.4917 23.3813V18.6749C22.4913 18.5268 22.4521 18.3813 22.3776 18.253C22.3032 18.125 22.1964 18.0184 22.0679 17.9447ZM21.2202 17.827H11.9344L10.9175 16.6635C10.7565 16.4796 10.524 16.374 10.2796 16.374H4.27086V2.19427C4.27086 1.96954 4.36014 1.75389 4.51904 1.59499C4.67794 1.43609 4.89359 1.34681 5.11832 1.34681H15.1649V5.70708C15.1649 6.15653 15.3435 6.58766 15.6614 6.90544C15.9792 7.22343 16.4104 7.402 16.8598 7.402H21.2201L21.2202 17.827Z",
    fill: "#333448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 9.73438V14H7.96973V9.73438H8.92188ZM10.2197 9.73438V10.4756H6.69824V9.73438H10.2197ZM11.5 9.73438L12.25 11.1875L13 9.73438H14.0898L12.877 11.8496L14.1221 14H13.0234L12.25 12.5205L11.4795 14H10.3779L11.626 11.8496L10.4102 9.73438H11.5ZM16.498 9.73438V14H15.5459V9.73438H16.498ZM17.7959 9.73438V10.4756H14.2744V9.73438H17.7959Z",
    fill: "#333448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon02);
export default __webpack_public_path__ + "static/media/pdf-icon-02.b1427d428514b0387036c350ffbebd64.svg";
export { ForwardRef as ReactComponent };